const tables = [
    {
        name: "Number"
    },
    {
        name: "Customer"
    },
    {
        name: "Date"
    },
    {
        name: "Expiry"
    },
    {
        name: "Salesman"
    },
    {
        name: "Deposit"
    },
    {
        name: "Total"
    },
    {
        name: "Status"
    },
    {
        name: "Action"
    },
];

export default tables;